import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** Its own area, not an HR tab: the people who write a rota are rarely those who keep personnel
 * files. */
export const Route = createFileRoute("/_authenticated/_workforce/schedule")({
  beforeLoad: ({ context }) => guardRoute(context.me, "schedule"),
  component: Outlet,
});
